<div>
    <mat-toolbar color="">
        <mat-toolbar-row class="container">
            
            <span class="header-logo text-right"><a href="/">
                    <img src="./assets/img/logo-sura.svg" class="img-fluid border-0" alt="Plataforma de Votación"> </a>
            </span>
            
            <span class="header-spacer"></span>
            
            <div class="margin-top-5">
	            <span class="header-title">ASAMBLEA</span>
            </div>
            
            
        </mat-toolbar-row>
    </mat-toolbar>
    <mat-divider></mat-divider>
    <main class="content">
        <router-outlet></router-outlet>
    </main>
    <footer>
        <sura-pie-pagina></sura-pie-pagina>
    </footer>
</div>
<sura-loader></sura-loader>